<template lang="pug">
.analysis-tab
  DataTable(:value="mappedResults" class="data-table" :filters="filters" :globalFilterFields="['name']")
    template(#header)
      .table-header
        .title Dwelling details
        InputText(v-model="filters.global.value" placeholder="Search...")
    template(#empty)
      .empty No results found
    Column(field="name" header="")
    Column(field="before" header="Before")
    Column(field="after" header="After")

  DataTable(:value="grantMeasures" class="data-table")
    template(#header)
      .table-header
        .title Grants per measure
    Column(field="measure" header="Measure")
    Column(field="grant" header="Grant")

  DataTable(:value="grantExtras" class="data-table")
    template(#header)
      .table-header
        .title Other grants
    Column(field="name" header="Name")
    Column(field="grantConditionMessage" header="Condition"  )
    Column(field="formattedGrantCost" header="Grant" style="min-width: 12rem;")

  DataTable(v-if="notifications.length" :value="notifications" class="data-table")
    template(#header)
      .table-header
        .title Notifications
    Column(field="details" class="empty" )
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { useRecommendations } from "@/store";
import { storeToRefs } from "pinia";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode } from "primevue/api";
import InputText from "primevue/inputtext";
import { formatNumberToString } from "@/helpers";

export default defineComponent({
  name: "AnalysisTab",
  components: {
    DataTable,
    Column,
    InputText,
  },
  setup() {
    const { report } = storeToRefs(useRecommendations());
    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const grantExtras = computed(() =>
        (report.value?.grantExtras ?? []).map(g => ({
          ...g,
          formattedGrantCost: formatNumberToString(g.grantCost)
        }))
    )

    const formatNumber = (value: number) => {
      if (value == undefined || isNaN(Number(value))) {
        return "-";
      }
      return new Intl.NumberFormat(undefined, {
        useGrouping: true,
        maximumFractionDigits: 2,
      }).format(value);
    };

    const mappedResults = computed(() =>
      report.value?.resultsAnalysis
        ? Object.keys(report.value.resultsAnalysis.before).map((key) => ({
            name: key,
            before: formatNumber(
              (report.value?.resultsAnalysis.before as any)[key]
            )?.toString(),
            after: formatNumber(
              (report.value?.resultsAnalysis.after as any)[key]
            )?.toString(),
          }))
        : []
    );

    const grantMeasures = computed(
      () =>
        report.value?.resultsAnalysis.appliedRecommendations.map((rec) => ({
          measure: rec.name,
          grant: formatNumberToString(rec.grantCost),
        })) || []
    );

    const notifications = computed(() => report.value?.notifications || []);

    return {
      mappedResults,
      grantMeasures,
      filters,
      formatNumber,
      notifications,
      grantExtras,
    };
  },
});
</script>

<style lang="scss">
.analysis-tab {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  max-width: 67.5vw;
  overflow: hidden;

  .data-table {
    border: 1px solid $border-color;
  }

  .extra-grant {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    .name {
      font-weight: bold;
    }
  }
  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      padding-left: 1rem;
      font-size: 1.5rem;
      color: $primary-color;
    }
  }

}
</style>
